import OrganicWaste from '../components/OrganicWaste';

function OrganicWastePage() {
  return <OrganicWaste />;
}

export default OrganicWastePage;
